import { EVENT_TYPE } from 'constants/logger';

import analytics from 'modules/analytics';
import { useEffect } from 'react';

const useTrackComponentMounted = (component: string) => {
  useEffect(() => {
    analytics.trackEvent(EVENT_TYPE.COMPONENT_MOUNTED, {
      component,
      load_time: window.performance.now(),
    });
  }, [component]);
};

export default useTrackComponentMounted;
